import SupportContent from './content'

export default function Support() {
  return (
    <div className="container mb-40">
      <div className="mx-auto flex max-w-6xl justify-center rounded-xl border border-border p-10 shadow-md md:shadow-xl">
        <SupportContent />
      </div>
    </div>
  )
}
